export const restDocument = {
	data () {
		return {
			doc: {
				id_groups: [],
				filename: '',
				description: '',
				file: null,
			},
			docs: [],
			groups: [],
			allowedExtensions: ['pdf', 'mp4'],
			maxFileSizeByExtension: {
				pdf: 32 * 1024 * 1024,  //32MB
				mp4: 128 * 1024 * 1024  //128MB
			}
		}
	},
	methods:{
		getDocumentGroups () {
			const backendurl = this.$store.getters.backendurl
			return this.$http.get(`${backendurl}api/v1/groups/document-options`)
				.then((response) => {
					this.groups = response.data || []
					return this.groups
				})
				.catch((error) => {
					console.error(error)
					this.validationMessage = error.response && error.response.data
						? error.response.data.message
						: 'No es posible cargar los grupos de usuarios'
					return Promise.reject(error)
				})
		},
		getDocsPages (page, search= '', sortKey= '', sortOrder= 'asc', size= 10) {
		const backendurl = this.$store.getters.backendurl
		const params = new URLSearchParams({ page, size })
		if (search) params.set('search', search)
		if (sortKey) params.set('sort', sortKey)
		params.set('order', sortOrder)

		//caracter final '/' de api retorna todos sin paginación, quitar para paginación
		this.$http.get(`${backendurl}api/v1/documents?${params.toString()}`)
			.then((response) =>{
				this.docs = response.data || []
				this.totalPages = response.headers.totalpages === undefined
					? 0
					: parseInt(response.headers.totalpages, 10)
		})
		.catch((error) =>{
			console.error(error)
			this.message = error.response.data.message
		})
		},
		getDocumentsForOrder (idGroup) {
			return this.$http
				.get(`${this.$store.getters.backendurl}api/v1/documents/order/${idGroup}`)
				.then((response) => response.data || [])
		},
		putDocumentsOrder (idGroup, documentIds) {
			return this.$http.put(
				`${this.$store.getters.backendurl}api/v1/documents/order/${idGroup}`,
				{ document_ids: documentIds }
			)
		},
		postDoc (cancelToken) {
			const backendurl = this.$store.getters.backendurl
			const formData = new FormData()
			formData.append('filename', this.doc.filename)
			formData.append('description', this.doc.description)
			this.doc.id_groups.forEach((idGroup) => formData.append('id_groups', idGroup))
			formData.append('file', this.doc.file)
			return this.$http.post(`${backendurl}api/v1/documents`, formData, { cancelToken })
				.then(() => {
					this.$router.push(`/documentos`)
				})
				.catch((error) => {
					//Cancelación pedida por el usuario: no es un error que mostrar.
					if (this.$http.isCancel(error)) {
						return
					}
					console.error(error)
					const status = error.response && error.response.status
					if (status === 413) {
						this.validationMessage = 'El archivo es demasiado grande.'
					} else if (status === 422) {
						this.validationMessage = 'El archivo fue rechazado por el análisis de seguridad.'
					} else if (status === 503) {
						this.validationMessage = 'El análisis antivirus no está disponible. Reintente en unos minutos.'
					} else {
						this.validationMessage = error.response && error.response.data && error.response.data.message
							? error.response.data.message
							: 'Ocurrió un error inesperado'
					}
				})
		},
		getDoc () {
			const backendurl = this.$store.getters.backendurl
			return this.$http.get(`${backendurl}api/v1/documents/${this.$route.params.idDoc}`)
				.then((response) => {
					this.doc = response.data
					//Documentos legacy no tienen todavía la asociación de grupos.
					if (!Array.isArray(this.doc.id_groups)) {
						this.$set(this.doc, 'id_groups', [])
					}
				})
				.catch((error) => {
					console.error(error)
					this.validationMessage = error.response && error.response.data
						? error.response.data.message
						: 'No es posible encontrar el documento'
				})
		},
		putDoc () {
			const backendurl = this.$store.getters.backendurl
			return this.$http.put(`${backendurl}api/v1/documents/${this.$route.params.idDoc}`, this.doc)
				.then(() => {
					this.$router.push('/documentos')
				})
				.catch((error) => {
					console.error(error)
					this.validationMessage = error.response && error.response.data
						? error.response.data.message
						: 'Ocurrió un error inesperado'
				})
		},
		toggleDocVisibility (idDoc) {
			const backendurl = this.$store.getters.backendurl
			return this.$http.put(`${backendurl}api/v1/documents/${idDoc}/visibility`)
		},
		getVisibleDocumentGroups () {
			const backendurl = this.$store.getters.backendurl
			return this.$http.get(`${backendurl}api/v1/documents/visible/groups`)
		},
		getVisibleDocs (idGroup = '') {
			const backendurl = this.$store.getters.backendurl
			const params = idGroup ? `?group_id=${encodeURIComponent(idGroup)}` : ''
			return this.$http.get(`${backendurl}api/v1/documents/visible${params}`)
		},
		contentUrl (item) {
			return `${this.$store.getters.backendurl}api/v1/documents/${item.id}/content`
		},
		//Misma fuente que el backend (filepath.Ext(FilePath) en RenderOneDocument):
		//'fileextension' es un campo legacy que puede venir vacío.
		fileExtension (item) {
			return (item.path || '').split('.').pop().toLowerCase()
		},
		deleteDoc () {
			const backendurl = this.$store.getters.backendurl
			return this.$http.delete(`${backendurl}api/v1/documents/${this.$route.params.idDoc}`)
				.then(() => {
					this.$router.push('/documentos')
				})
				.catch((error) => {
					console.error(error)
					this.validationMessage = error.response && error.response.data
						? error.response.data.message
						: 'Ocurrió un error inesperado'
				})
		}
	},
}
